import type { IFields, ISpreadingJobFieldUpdate } from '@/interfaces'
import Base from '../Base'

class SpreadingJobFieldUpdate extends Base implements ISpreadingJobFieldUpdate {
  fieldId: string | null
  field?: IFields | undefined
  methodType: string | null
  tonnageUseByArea: number
  areaInHectare: number
  actualTonnageUse: number
  hasMaterialShortage: boolean
  hasOdourNuisance: boolean
  hasWaterPollution: boolean
  notes: string | null

  constructor(data?: any) {
    super(data)
    this.fieldId = data?.fieldId ?? null
    this.field = data?.field
    this.methodType = data?.methodType ?? null
    this.tonnageUseByArea = data?.tonnageUseByArea ? data?.tonnageUseByArea : 0
    this.areaInHectare = data?.areaInHectare ? data?.areaInHectare : 0
    this.actualTonnageUse = data?.actualTonnageUse ? data?.actualTonnageUse : 0
    this.hasMaterialShortage = data?.hasMaterialShortage ?? false
    this.hasOdourNuisance = data?.hasOdourNuisance ?? false
    this.hasWaterPollution = data?.hasWaterPollution ?? false
    this.notes = data?.notes ?? null
  }
}

export default SpreadingJobFieldUpdate
